module.exports = __webpack_public_path__ + "img/7560992.png";